import {assert} from 'wnd-util';
import {PrivacyPage} from '>root/pages/privacy';
import {CookiePage} from '>root/pages/cookie';
import {AppRoute, findRoutePathFromLabel} from '>shared/lib/navigation';

export enum RouteLabel {
  Privacy = 'Privacy',
  Cookie = 'Cookie',
}

export enum RoutePath {
  Privacy = '/',
  Cookie = '/cookie-policy',
}

export const routes: Array<AppRoute<RouteLabel>> = [
  {
    path: RoutePath.Privacy,
    label: RouteLabel.Privacy,
    Component: PrivacyPage,
  },
  {
    path: RoutePath.Cookie,
    label: RouteLabel.Cookie,
    Component: CookiePage,
  },
];

export function findPathFromLabel(label: RouteLabel) {
  const path = findRoutePathFromLabel(label, routes);
  assert.assertExists(path, 'All path labels should be referenced by the routes');

  return path;
}
